module.exports = __webpack_public_path__ + "static/media/youtube.63c274ce.svg";